// src/alertUtils.js
import { useToasts } from "react-toast-notifications";

import Cookies from "js-cookie";

export default function useAlertUtils() {
  const { addToast } = useToasts();

  const alertSuccess = (message) => {
    addToast(message, {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 4000,
    });
  };

  const alertError = (message) => {
    addToast(message, {
      appearance: "error",
      autoDismiss: true,
      autoDismissTimeout: 4000,
    });
  };

  const alertWarn = (message) => {
    addToast(message, { appearance: "error" });
  };

  return { alertSuccess, alertError, alertWarn };
}

export const setCookie = (key, value, expires) => {
  Cookies.set(key, value, { expires });
};

export const getCookie = (key) => {
  return Cookies.get(key);
};

// Phone number validation for US format
export const validateUSPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return { isValid: false, error: 'Phone number is required' };
  }
  
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Check if it's exactly 10 digits
  if (cleaned.length !== 10) {
    return { 
      isValid: false, 
      error: 'Phone number must be exactly 10 digits (e.g., (555) 555-5555)' 
    };
  }
  
  // Check if it starts with valid area code (not 0 or 1)
  if (cleaned[0] === '0' || cleaned[0] === '1') {
    return { 
      isValid: false, 
      error: 'Phone number cannot start with 0 or 1' 
    };
  }
  
  // Check if second digit of area code is 0 or 1 (invalid)
  if (cleaned[1] === '0' || cleaned[1] === '1') {
    return { 
      isValid: false, 
      error: 'Invalid area code format In Phone Number' 
    };
  }
  
  return { isValid: true, cleaned };
};

// Format phone number for display
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  const cleaned = phoneNumber.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNumber;
};
